var map = {
	"./1.jpg": 77998,
	"./2.jpg": 85113,
	"./3.jpg": 64060,
	"./4.jpg": 70055,
	"./5.jpg": 14218,
	"./6.jpg": 40469,
	"./7.jpg": 32600,
	"./8.jpg": 707,
	"./preview_gin.jpg": 56544,
	"./preview_whisky.jpg": 12945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71920;